import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

const MOBILE = '@media (max-width: 960px)';

export const Wrap = styled.div`
  width: 100%;
  padding: 8.8rem 7.2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.4rem;

  ${MOBILE} {
    padding: 4.8rem 2.4rem 0;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 112rem;

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: ${LandingHero.neutral.cardBg};
  border: 0.1rem solid ${LandingHero.neutral.cardBorder};
  border-radius: 2.2rem;
  padding: 3rem 2.8rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  backdrop-filter: blur(1.2rem);
  -webkit-backdrop-filter: blur(1.2rem);
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), border-color 0.4s ease;

  &:hover {
    transform: translateY(-0.6rem);
    border-color: ${LandingHero.creator.cardBorder};
  }

  ${MOBILE} {
    padding: 2rem 1.8rem;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Number = styled.div<{ $highlight?: boolean }>`
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 0.9rem;
  background: ${({ $highlight }) =>
    $highlight ? LandingHero.ctaGradient : LandingHero.skyCtaGradient};
  color: ${({ $highlight }) =>
    $highlight ? LandingHero.ctaText : LandingHero.skyCtaText};
  font-family: ${HERO_FONT_DISPLAY};
  font-size: 1.3rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Title = styled.div`
  font-size: 1.7rem;
  font-weight: 800;
  color: ${LandingHero.textPrimary};
`;

export const Description = styled.div`
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${LandingHero.textMuted};
`;
